
import { Image, TooltipContent } from '../../../shared/shared.interface';
import { KngButtonState } from '../../button';

export interface KngTable {
  state: KngTableState;
}
export interface KngTableState {
  gridHeaders: HeaderObj[];
  gridData: GridValue[];
  ribbon: { ctaList: CtaList[]; cancelButton: KngButtonState };
  itemsSelected: string;
  isCheckbox: boolean;
  isRibbon: boolean;
  selectAll?:string;
  loading?: boolean;
  noResult: {
    image:Image;
    text:string;
  };
  approveUserLimitIndicatorText?: string;
  cssClass?:string;
  isTooltipPresent?: boolean;
  tooltip?: TooltipContent;
  tooltipClass?: string;
  id?:string;
  permissionCheckBoxDisabled?: boolean;
}

export interface GridValue {
  values: GridValueData[];
  id:string;
  checked?:boolean;
  email?: string;
  state?: string;
  portalUserId?: string;
  company: string;
  roles: string[];
  portalApprovedCustomerID: string[];
  tempIsPrefilled?: boolean;
  phoneNumber: string;
  roleName: string;
  disabled?:boolean | undefined;
  adminLocationID?: string | undefined;
}
export interface BusinessAccountGridValue {
  values: GridValueData[];
  id:string;
  email?: string;
  phoneNumber: string;
}

export interface CtaList {
  id: string;
  className: string | AprRejBtnType;
  state: KngButtonState;
}

export interface HeaderObj {
  id?:string;
  label: string;
  category?: string;
  isTooltip?:boolean;
}

export interface GridValueData {
  label: string;
  value: string | boolean | number;
  href?: string;
  category?: KngTableCategory;
  firstLineValue?: string;
  secondLineValue?: string;
  thirdLineValue?:string;
  icon?:Image;
  cssClass?:string;
  isTooltip?:boolean;
  count?: string | number;
  options?: {
    id: string;
    name: string;
    description: string;
  }[];
  ctaList: CtaList[];
  redirectionDisabled?: boolean;
  hideLink?: boolean;
  roleDisabled?: boolean;
  disabled?: boolean;
  className?: string | '';
}

export interface AprRejActionData {
  action: string | AprRejBtnType;
  selectedUserData: AprRejUserData[];
  selectedUserDataForApprove: ApproveUserData[];
}
export interface AprRejUserData {
  id: string;
  email: string;
  state: string;
}
export interface ApproveUserData {
  id: string;
  email: string;
  state: string;
  portalUserId: string;
  company: string;
  roles: string[];
  portalApprovedCustomerID?: string[];
  adminLocationID?: string;
  tempIsPrefilled: boolean;
  phoneNumber: string;
  roleName: string;
}

export type KngTableCategory =
  | 'checkbox'
  | 'link'
  | 'multiline'
  | 'button'
  | 'primary'
  | 'select'
  | 'date'
  | 'editData'
  | 'uploadFile';

export enum TableCategory {
  link = 'link',
  multiline = 'multiline',
  button = 'button',
  select = 'select',
  checkbox = 'checkbox',
  date='date',
  primary='primary',
  editData='editData',
  uploadFile='uploadFile'
}

export enum AprRejBtnType {
  singleApprove  = 'singleApprove',
  singleReject = 'singleReject',
  bulkApprove = 'bulkApprove',
  bulkReject = 'bulkReject'
}
